// *For User Data
export const setUserData = (payload) => ({
  type: "user_data",
  payload
});

export const setToogleHeader = (payload) => ({
  type: "toggle_header",
  payload,
});
